import _ from 'underscore';

import { FlowParameter } from '~src/flow/types/FlowParameters';

import { MapperHelper } from '../../../spacesPlatform/models/mappers/MapperHelper';
import { FlowOutputStep } from '../../serverApi/types/FlowOutputStep';
import { FlowOutputStepRun } from '../../serverApi/types/FlowOutputStepRun';
import { FlowRun, FlowRunTriggerType } from '../../serverApi/types/FlowRun';
import { FlowRunErrorUniqueKey } from '../../serverApi/types/FlowRunError';
import { FlowOutputStepRunListItemInfo, FlowOutputStepRunType } from '../FlowOutputStepRunInfo';

export module FlowOutputStepRunMapper {

  export function map(
    steps: FlowOutputStepRun[],
    outputs: _.Dictionary<FlowOutputStep>,
    runs: _.Dictionary<FlowRun>,
    jobRetentionDays: number,
  ): FlowOutputStepRunListItemInfo[] {
    return _.map(steps, (s: FlowOutputStepRun) => mapOne(s, outputs, runs, jobRetentionDays));
  }

  export function mapOneForAlert(
    s: FlowOutputStepRun,
    outputs: _.Dictionary<FlowOutputStep>,
  ): FlowOutputStepRunListItemInfo {
    return {
      id: s.id,
      contentType: 'flowOutputStepRun',
      flowId: s.flowId,
      flowLuid: s.flowLuid,
      startedAt: MapperHelper.toDate(s.startedAt),
      completedAt: MapperHelper.toDate(s.completedAt),
      status: s.status,
      rowsProduced: s.rowsProduced >= 0 ? s.rowsProduced : 0,
      flowRunId: s.flowRunId,
      flowOutputStepId: s.flowOutputStepId,
      outputName: outputs[s.flowOutputStepId] != null ? outputs[s.flowOutputStepId].name : '',
      runType: FlowOutputStepRunType.unknown,
      publishedDataSourceId: s.publishedDataSourceId,
      publishedDataSourceName: s.publishedDataSourceName,
      flowRunErrors: s.errors ? _.uniq(s.errors, false, FlowRunErrorUniqueKey) : [],
      isIncremental: s.isIncremental,
    };
  }

  export function mapOne(
    s: FlowOutputStepRun,
    outputs: _.Dictionary<FlowOutputStep>,
    runs: _.Dictionary<FlowRun>,
    jobRetentionDays: number,
  ): FlowOutputStepRunListItemInfo {
    const flowRun = runs[s.flowRunId];
    const triggerType = flowRun != null ? flowRun.triggerType : null;
    const runType = triggerType != null && triggerType === FlowRunTriggerType.adhoc ?
      FlowOutputStepRunType.ondemand :
      triggerType != null && triggerType === FlowRunTriggerType.scheduled ?
        FlowOutputStepRunType.scheduled :
        FlowOutputStepRunType.unknown;

    let parameters: FlowParameter[] = [];
    Object.keys(outputs).forEach(id => {
      if(outputs[id].relevantParameters && outputs[id].relevantParameters.length > 0) {
        parameters = parameters.concat(outputs[id].relevantParameters);
      }
    });
    return {
      id: s.id,
      contentType: 'flowOutputStepRun',
      flowId: s.flowId,
      flowLuid: s.flowLuid,
      startedAt: MapperHelper.toDate(s.startedAt),
      completedAt: MapperHelper.toDate(s.completedAt),
      status: s.status,
      rowsProduced: s.rowsProduced >= 0 ? s.rowsProduced : 0,
      flowRunId: s.flowRunId,
      flowOutputStepId: s.flowOutputStepId,
      outputName: outputs[s.flowOutputStepId] != null ? outputs[s.flowOutputStepId].name : '',
      runType: runType,
      backgroundJobId: flowRun != null ? flowRun.backgroundJobId : undefined,
      publishedDataSourceId: s.publishedDataSourceId,
      publishedDataSourceName: s.publishedDataSourceName,
      flowRunErrors: s.errors ? _.uniq(s.errors, false, FlowRunErrorUniqueKey) : [],
      isIncremental: s.isIncremental,
      relevantParameterRuns: s.relevantParameterRuns,
      jobRetentionDays: jobRetentionDays,
    };
  }
}
